module.exports = __webpack_public_path__ + "media/logos/logo-contxto-b36043b1.png";